module.exports = __webpack_public_path__ + "img/paper.ce03e73b.svg";